/* Typography animation*/

document.addEventListener("DOMContentLoaded", function() {
  
  const headings = document.querySelectorAll(
    "h1:not(.card--text-content h1), h2:not(.card--text-content h2), h3:not(.card--text-content h3), h4:not(.card--text-content h4), h5:not(.card--text-content h5), h6:not(.card--text-content h6)"
  );

 
  headings.forEach(function(heading) {
    heading.classList.add("fade-in-up", "in-view");
  });
});





/* add active link to custom liquid category filter on blog page */
    document.addEventListener('DOMContentLoaded', function() {
    const categoryLinks = document.querySelectorAll('#category-links .category-link');

    function setActiveLink() {
        const currentPath = window.location.pathname;
        
        categoryLinks.forEach(function(link) {
            if (link.getAttribute('href') === currentPath) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }

    // Set the active link when the page loads
    setActiveLink();

    // Optional: If you want the active class to change on click without reloading the page
    categoryLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            categoryLinks.forEach(function(l) {
                l.classList.remove('active');
            });
            this.classList.add('active');
        });
    });
});

/* active link for the resources page */
document.addEventListener('DOMContentLoaded', function() {
    const resourceLinks = document.querySelectorAll('#resource-category-links .category-link');

    function setActiveResourceLink() {
        const currentPath = window.location.pathname;

        resourceLinks.forEach(function(link) {
            if (link.getAttribute('href') === currentPath) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }

    setActiveResourceLink();

    resourceLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            resourceLinks.forEach(function(l) {
                l.classList.remove('active');
            });
            this.classList.add('active');
        });
    });
});





document.addEventListener("DOMContentLoaded", function () {
    var elements = document.querySelectorAll(".in-view");
    var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add("animate");
            } else {
                entry.target.classList.remove("animate");
            }
           
            
		 
        });
    });
    elements.forEach((element) => {
        observer.observe(element);
    });
});
